export default __webpack_public_path__ + "static/media/usdz.90f6a6c9.svg";